$(function() {
    // Toggle overlay
    $('[data-toggle="overlay"]').click(function() {
        target = $(this).data('target');

        $(target).toggleClass('active');

        if (target === '#sidebarProjects') {
            // Check if transition of target has ended
            $(target).one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function() {
                // Repaint scheduler when transition ends
                //$("#scheduler").dxScheduler('instance').repaint();
                 var firstDataCell = $('.dx-scheduler-date-table') ;
                var tableWidth = firstDataCell.innerWidth();
                var cellWidth = tableWidth/7;
                var appointments = $(".dx-scheduler-appointment");
                appointments.each(function( index, element ) {
                    var transform = $( element ).css('transform').replace(/[^0-9\-.,]/g, '').split(',');
                    var currCellWidth = $( element ).css('width').replace("px", "");
                    var newLeft = (cellWidth) * (parseInt(Math.round(transform[4]/currCellWidth)));
                    $( element ).css( "transform", "translate(" + newLeft + "px," + transform[5] + "px)");
                    $( element ).css( "width", cellWidth );
                });

                // Remove sidebar-replacement element
                if (!$('#sidebarProjects').hasClass('active')) {
                    $('#stickyShadow').remove();
                }
            });

            var sidebarShadow =  document.getElementById('stickyShadow');

            if (!sidebarShadow && $('#sidebarProjects').hasClass('sticky')) {
                // var sidebar = document.getElementById('sidebarProjects');
                var width = 300;

                $('.app').append(
                    '<div id="stickyShadow" style="'+
                            'width:' + width + 'px;'+
                            'flex: 0 0 ' + width + 'px;' +
                    '"></div>');
            } else if (sidebarShadow) sidebarShadow.remove();
        }
    });
});



// WEBPACK FOOTER //
// ./resources/js/components/overlays.js